module.exports = __webpack_public_path__ + "img/account-icon.d280b6c1.svg";